import { fromJS } from 'immutable';
import * as constants from './metaData-constants';

const initialState = fromJS({
  gotMetaDataCount: false,
  followersCount: 0,
  followsCount: 0,
  postsCount: 0,
  likesCount: 0,
  followers: [],
  follows: [],
  posts: [],
  loading: false,
});

export default function metaDataReducer(state = initialState, { type, payload }) {
  switch (type) {
    case constants.GOT_META_DATA_COUNT:
    case constants.UPDATE_PROPS:
      return state.merge(fromJS(payload));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/newsfeed/metaData/metaData-reducer.js